import * as ListActions from './list';
import * as OrdersActions from './orders';

const Actions = {
  ...ListActions,
  ...OrdersActions,
};

export default Actions;
